module.exports = __webpack_public_path__ + "img/main_18.7e2923ca.jpg";